import { useSyncExternalStore } from 'react';

export type ThemePreference = 'light' | 'dark' | 'system';

declare global {
  interface Window {
    aelitaTheme: {
      getSnapshot: () => ThemePreference;
      setPreference: (value: ThemePreference) => void;
      subscribe: (listener: () => void) => () => void;
    };
  }
}

export function useTheme() {
  const preference = useSyncExternalStore(
    window.aelitaTheme.subscribe,
    window.aelitaTheme.getSnapshot,
  );
  return { preference, setPreference: window.aelitaTheme.setPreference };
}
